import { parseAsString, useQueryState } from "nuqs";

const segmentIdParser = parseAsString.withOptions({ history: "replace", shallow: false });

export function useTeamSegment() {
    return useQueryState("team-segment", segmentIdParser);
}
